// Copyright (c) 2026 Goffy. All Rights Reserved. This file belongs to Goffy.

export const getApiBaseUrl = () => {
  const envBase = process.env.EXPO_PUBLIC_API_BASE_URL;
  if (envBase) return envBase;

  if (typeof window !== 'undefined' && window.location?.origin) {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return origin;
    }
  }
  return 'https://backend.goffy.app';
};
